import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var legendBaseState = {
  enabled: true,
  showAlert: false,
  position: 'right',
  colour: '#000000'
};
var dimensionsBaseState = {
  width: 500,
  height: 500
};
var axesBaseState = {
  xAxisText: '',
  yAxisText: '',
  titleFontSize: 13,
  labelFontSize: 12,
  offset: 0,
  gridOpacity: 0,
  gridWidth: 10,
  domainWidth: 2,
  xAxisRotateLabels: false
};
var axesRangesBaseState = {
  xAxisAuto: true,
  yAxisAuto: true,
  xMin: 0,
  xMax: 10,
  yMin: 0,
  yMax: 10
};
var titleBaseState = {
  text: '',
  fontSize: 15,
  anchor: 'start',
  dx: 10
};
var fontStyleBaseState = {
  font: '"M Plus 2"',
  colour: '#000000'
};
var colourBaseState = {
  masterColour: '#000000',
  gradient: 'default',
  toggleInvert: '#FFFFFF',
  invert: 'standard',
  reverseColourBar: false
};
var markerBaseState = {
  shape: 'circle',
  showOpacity: true,
  opacity: 5,
  size: 5
};
var embeddingMarkerBaseState = _objectSpread(_objectSpread({}, markerBaseState), {}, {
  size: 1
});
var labelBaseState = {
  enabled: true,
  size: 18,
  overlapRepel: 0.0
};
export { legendBaseState, dimensionsBaseState, axesBaseState, axesRangesBaseState, titleBaseState, fontStyleBaseState, colourBaseState, markerBaseState, embeddingMarkerBaseState, labelBaseState };